module.exports = __webpack_public_path__ + "static/frank-bd8a8fefa8cb19893ffca4b2c6652673.png";